import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.0035 2.00195L11.0035 1.99805L11.0014 3.08266C8.48696 3.50372 6.50245 5.48865 6.08203 8.00333H17.9172C17.497 5.48984 15.5142 3.5056 13.0014 3.08326L13.0035 2.00195Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 10H2V12H3V22H8V16H16V22H21V12H22V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 22V18H14V22H10Z"}}]};

const MosqueFilled = Vue.extend<IconProps>({
  name: 'MosqueFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'mosque-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MosqueFilled;
